<template>

<core-modal-setting title="Stickiness" :value="valueText" placeholder="Disabled">
        
    <core-input-checklist 
        :options="options"
        v-model="internalValue"
    />

</core-modal-setting>

</template>

<script>

import mixSetting from 'core/mixin/modal/Setting'

export default {

    mixins: [mixSetting],

    computed: {

        options: function() {

            return [
                {
                    value: 0,
                    text: 'Disabled'
                },
                {
                    value: 1,
                    text: 'All screens'
                },
                {
                    value: 2,
                    text: 'Large screens only'
                }
            ]

        }

    }

}

</script>

<style scoped>

</style>